module.exports = __webpack_public_path__ + "static/media/add-cart.c95fd428.svg";